import { useContext } from "react";
import ColorContext from "../contexts/ColorProvider";

const useColor = () => {
  return useContext(ColorContext);
};

export default useColor;